export function detectOS() {
    var userAgent = navigator.userAgent;
  
    if (/Android/i.test(userAgent)) {
      return "Android";
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
      return "iOS";
    } else if (/Windows/i.test(userAgent)) {
      return "Windows";
    } else if (/Linux/i.test(userAgent)) {
      return "Linux";
    } else if (/Macintosh|Mac OS X/i.test(userAgent)) {
      return "Mac";
    } else {
      return "Unknown";
    }
  }
  
  export function getOSVersion() {
    const userAgent = navigator.userAgent;
    let osVersion = "";
  
    if (userAgent.indexOf("Windows") !== -1) {
      // Windows
      const match = userAgent.match(/Windows NT (\d+\.\d+)/);
      if (match) {
        osVersion = match[1];
      }
    } else if (userAgent.indexOf("Mac OS X") !== -1) {
      // macOS
      const match = userAgent.match(/Mac OS X (\d+[\.]\d+(?:[\.]\d+)?)/);
      if (match) {
        osVersion = match[1].replace(/_/g, ".");
      }
    } else if (userAgent.indexOf("Linux") !== -1) {
      // Linux
      const match = userAgent.match(/Linux/);
      if (match) {
        osVersion = "Linux";
      }
    } else if (userAgent.indexOf("Android") !== -1) {
      // Android
      const match = userAgent.match(/Android (\d+(\.\d+)?)/);
      if (match) {
        osVersion = match[1];
      }
    } else if (userAgent.indexOf("iOS") !== -1) {
      // iOS
      const match = userAgent.match(/OS (\d+(_\d+)?)/);
      if (match) {
        osVersion = match[1].replace(/_/g, ".");
      }
    }
  
    return osVersion;
  }
  
  export function browserCheck() {
    let userAgent = navigator.userAgent;
  
    // Detect Chrome
    if (/Edg/.test(userAgent)) {
      // browser = "Microsoft Edge";
      return "Microsoft Edge";
    } else if (/Chrome/.test(userAgent) && !/Chromium/.test(userAgent)) {
      // browser = "Google Chrome";
      return "Google Chrome";
    }
  
    // Detect Firefox
    else if (/Firefox/.test(userAgent)) {
      return "Mozilla Firefox";
    }
    // Detect Safari
    else if (/Safari/.test(userAgent)) {
      // browser = "Apple Safari";
      return "Apple Safari";
    }
    // Detect Internet Explorer
    else if (/Trident/.test(userAgent)) {
      // browser = "Internet Explorer";
      return "Internet Explorer";
    }
    // console.log("current browser is : " + browser);
  }
  
  export function browserVersionCheck() {
    let userAgent = navigator.userAgent;
  
    if (/Edg/.test(userAgent)) {
      // browser = "Microsoft Edge";
      return userAgent.match(/Edg\/(\d+)/)[1];
    } else if (/Chrome/.test(userAgent) && !/Chromium/.test(userAgent)) {
      // browser = "Google Chrome";
      return userAgent.match(/Chrome\/(\d+)/)[1];
    }
    // Detect Chromium-based Edge
  
    // Detect Firefox
    else if (/Firefox/.test(userAgent)) {
      // browser = "Mozilla Firefox";
      return userAgent.match(/Firefox\/(\d+)/)[1];
      // setBrowserCopatibility(true);
    }
    // Detect Safari
    else if (/Safari/.test(userAgent)) {
      // browser = "Apple Safari";
      return userAgent.match(/Version\/(\d+)/)[1];
    }
    // Detect Internet Explorer
    else if (/Trident/.test(userAgent)) {
      // browser = "Internet Explorer";
      return userAgent.match(/Trident\/\d+.*rv:(\d+)/)[1];
    }
  }
  
  // export const getDateTimeInfo = () => {
  //   return new Date().toISOString().slice(0, -5);
  // };
  
  export const getDateTimeInfo = () => {
    // Get the current date and time in UTC
    const currentDate = new Date();
  
    // Convert UTC time to Indian Standard Time (IST)
    currentDate.setHours(currentDate.getHours() + 5); // Add 5 hours for UTC+5
    currentDate.setMinutes(currentDate.getMinutes() + 30); // Add 30 minutes for UTC+5:30
  
    // Format the date and time as per the requirement
    const formattedDateTime = currentDate.toISOString().slice(0, -5);
  
    return formattedDateTime;
  };
  
  export const getSystemSpecs = () => {
    let browserData = navigator;
    return {
      cookieEnabled: browserData.cookieEnabled,
      downLink: browserData.connection?.downLink,
      rtt: browserData.connection?.rtt,
      effectiveType: browserData.connection?.effectiveType,
      language: browserData.language,
      hardwareConcurrency: browserData.hardwareConcurrency,
      deviceMemory: browserData.deviceMemory,
      pdfViewerEnabled: browserData.pdfViewerEnabled,
    };
  };
  
  export const logData = () => {
    const osType = detectOS();
    const osVersion = getOSVersion();
    const browserType = browserCheck();
    const browserVersion = browserVersionCheck();
    const systemSpecs = getSystemSpecs();
    const dateTimeInfo = getDateTimeInfo();
    const logs = {
      osType,
      osVersion,
      browserType,
      browserVersion,
      systemSpecs,
      dateTimeInfo,
    };
    return logs;
  };
  